<template>
  <el-container>
    <el-drawer title="导入" :visible="importVisible" :before-close="handleClose" append-to-body
               :wrapperClosable="false"
               @open="handleOpen">
      <div style="height: calc(100% - 67px);">
        <el-scrollbar class="drawer_scrollbar">
          <el-row style="padding: 10px 30px 30px 30px">
            <el-upload
                ref="upload"
                drag
                action="#"
                :file-list="fileList"
                :on-exceed="onExceed"
                :before-upload="beforeUpload"
                :http-request="uploadFile"
                :on-success="onUploadSuccess"
                :on-error="onUploadError"
                :limit="fileMaxCount"
                :auto-upload="false">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip">
                只能上传
                <template v-for="(type,index) in fileSupportTypes">{{ index == 0 ? type : ("/" + type) }}</template>
                文件，且不超过 {{ fileMaxSize }} MB
              </div>

              <div class="el-upload__tip" slot="tip">
                <el-button style="border: none ; color: #409EFF ; background-color: white" @click="uploadTemplate">
                  下载模板
                </el-button>
              </div>
            </el-upload>
          </el-row>

        </el-scrollbar>
      </div>
      <span class="drawer_footer">
                <el-button type="primary" @click="submitData" size="medium"
                           :loading="uploadBtnLoading">{{ uploadBtnLoading ? '上传中...' : '确定' }}</el-button>
                <el-button @click="handleClose" :disabled="$store.state.loading" size="medium">取 消</el-button>
            </span>
    </el-drawer>
  </el-container>
</template>

<script>
import {importExamQuestion} from "@/api/core/examQuestion";


export default {
  name: "DoctorImportForm",
  data() {
    return {
      rules: {
      },
      fileList: [],
      importVisible: false,
      fileMaxSize: 10,//文件大小。单位:MB
      fileMaxCount: 1,//文件数量
      fileSupportTypes: ["xls", "xlsx"],//文件支持类型
      form: {},
      uploadBtnLoading: false,
      hospitalList:[],
      lessonBaseList:[],
    }
  },
  methods: {
    //下载模板
    uploadTemplate() {
        let url = "/core/examQuestion/downloadImportTemplate";
        window.open(url)
    },
    handleOpen() {

    },
    handleClose() {
      if (!this.uploadBtnLoading) {
        this.form = {};
        this.$refs.upload.clearFiles();
      }
      this.hospitalList = []
      this.lessonBaseList = []
      this.importVisible = false;
    },
    onExceed(files, fileList) {
      this.$message.warning(`当前限制选择 ${this.fileMaxCount} 个文件`);
    },
    beforeUpload(file) {
      const fileType = file.name.split('.')[file.name.split('.').length - 1];
      if (this.fileSupportTypes.indexOf(fileType) == -1) {
        this.$message.warning(`仅支持 ${this.fileSupportTypes} 格式的文件上传`);
        return false; // 返回false不会上传
      }
      const isLt2M = file.size / 1024 / 1024 < this.fileMaxSize;
      if (!isLt2M) {
        this.$message.warning(`文件大小不能超过 ${this.fileMaxSize} MB`);
        return false;
      }
      return this.uploadBtnLoading = true;
    },
    uploadFile(param) {
      let formData = new FormData()
      formData.append('file', param.file)
      importExamQuestion(formData).then(res => {
        if (res.status === 200) {
          this.$emit('refreshList');
          this.importVisible = false;
        }
      })
      this.$refs.upload.clearFiles();
      this.uploadBtnLoading =false;
      this.form = {};
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    onUploadSuccess(response, file, fileList) {
      this.uploadBtnLoading = false;
      if (response.status === 200) {
        this.$message.success(response.msg);
        this.handleClose();
        this.$emit('refreshList');
      } else {
        this.$message.error({
          showClose: true,
          duration: 0,
          message: response.msg
        });
      }
    },
    onUploadError(err, file, fileList) {
      this.uploadBtnLoading = false;
      this.$message.error({
        showClose: true,
        duration: 0,
        message: err
      });
      console.error(`onUploadError err=${err} file=${file} fileList=${fileList}`);
    },
   async submitData() {
      this.$refs.upload.submit();
      this.$refs.upload.clearFiles();
      this.uploadBtnLoading =false;
      this.importVisible = false;
    }
  }
}
</script>

<style scoped>

</style>